import CommunicationPanel from './CommunicationPanel';

export default CommunicationPanel;
